module.exports = __webpack_public_path__ + "static/media/pop-and-legend.4498dcd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maps/pop-and-legend.png
// module id = 1259
// module chunks = 0